// The Capablity KEYS!
const KBGP = 'kbgp';
const KDNS = 'kdns';
const KPROXY = 'kproxy'; // still behind a perm
const KSNMPTRAP = 'ksnmptrap'; // only behind a perm
const KSYSLOG = 'ksyslog'; // only behind a perm
const RANGER = 'ranger';
const KTRAFFIC = 'ktraffic';

// Block from public!
const LIVESYNTH = 'livesynth';
const KPACKET = 'kpacket';
const KSQUEEGEE = 'ksqueegee';
const KMETA = 'kmeta';

// NOT YET but planned
const KSYNTH = 'ksynth';

const KDUMMY = 'kdummy';
const KPTR = 'kptr';

// Defines the default configuration for each capability. When installing a capability, a new config object will be created with the args set in this map.
const CAPABILITIES_DEFAULT_CONFIGS = {
  [KDNS]: {
    args: {
      interface: 'any',
      fanoutCount: '4',
      enableCompression: true,
      promiscuous: false,
      sampleRate: 1
    }
  },
  [KPROXY]: {
    args: {
      host: '0.0.0.0',
      port: 9995,
      basePort: 40010,
      sflowAgentAddress: false,
      logLevel: 'info'
    }
  },
  [KSNMPTRAP]: {
    args: {}
  },
  [KTRAFFIC]: {
    args: {}
  },
  [KSYSLOG]: {
    args: {
      udpListenAddr: '0.0.0.0:514',
      tcpListenAddr: '0.0.0.0:514'
    }
  },
  [KSQUEEGEE]: {
    args: {}
  },
  [KSYNTH]: {
    args: {}
  },
  [KMETA]: {
    args: {}
  },
  [KPTR]: {
    args: {}
  },
  [KDUMMY]: {
    args: {}
  }
};

const CMD_ARGS_KPROXY_KEBAB_OBJ = ['proxyhttp', 'proxyhttpallow'];
const CMD_ARGS_KPROXY_KEBAB = ['-proxy-http', '-proxy-http-allow'];

const CAPABILITY_TITLES = {
  kbgp: 'BGP Proxy (AKA kbgp)',
  kdummy: 'Dummy Capability',
  kdns: 'DNS OTT Tap',
  kproxy: 'Flow Proxy (Edge Processing)',
  ksnmptrap: 'SNMP Trap Receiver',
  ksynth: 'Synthetics',
  ksyslog: 'Syslog Server',
  livesynth: 'Connectivity Test',
  ktraffic: 'Flow Proxy (Forwarding)',
  ranger: 'SNMP/ST',
  ksqueegee: 'Device Configuration Sync',
  kptr: 'Reverse DNS',
  kmeta: 'Metadata Collector'
};

const CAPABILITY_DESCRIPTIONS = {
  kbgp: 'Proxy local iBGP Route Reflector Client session from multiple hosts and multiplex them securely to Kentik SaaS cluster',
  kdns: 'Upon installation on a DNS server, collect and export DNS Query Responses to match against Flow Telemetry for OTT detection',
  kproxy:
    'Deploy this Flow Proxy (Edge Processing) capability as an on-prem relay to receive network flow telemetry ' +
    '(NetFlow v5/v9, sFlow, IPFIX) from registered devices, apply edge processing features such as IP obfuscation, ' +
    'and securely multiplex the resulting flow records to the Kentik SaaS cluster.',
  ksnmptrap: 'Receive SNMP Traps and securely transport them to Kentik',
  ksynth: 'Turns host into Kentik Synthetics Agent to perform Network, HTTP and DNS synthetic tests',
  ksyslog: 'Provides syslog server that transports logs to Kentik',
  ranger: 'Base layer of network visibility including up/down, interface stats, and hardware components',
  livesynth: 'Connectivity Test - Allows AI Advisor to run network tests (ping,trace) on demand',
  ktraffic:
    'Deploy this Flow Proxy (Forwarding) capability to receive and securely forward network flow telemetry to Kentik.',
  ksqueegee: 'Fetch and backup configuration from network devices',
  kptr: 'Resolves reverse DNS (PTR) lookups for flow data enrichment',
  kmeta: 'Fetch metadata using custom collectors and updates custom dimensions/populators',
  kdummy: 'Test Capability'
};

const CLUSTER_HEALTH_STATE_UNSPECIFIED = 'CLUSTER_HEALTH_STATE_UNSPECIFIED';
const CLUSTER_HEALTH_STATE_HEALTHY = 'CLUSTER_HEALTH_STATE_HEALTHY';
const CLUSTER_HEALTH_STATE_WARNING = 'CLUSTER_HEALTH_STATE_WARNING';
const CLUSTER_HEALTH_STATE_DEGRADED = 'CLUSTER_HEALTH_STATE_DEGRADED';
const CLUSTER_HEALTH_STATE_CRITICAL = 'CLUSTER_HEALTH_STATE_CRITICAL';
const CLUSTER_HEALTH_STATE_DOWN = 'CLUSTER_HEALTH_STATE_DOWN';

const clusterHealthStatusLabels = {
  CLUSTER_HEALTH_STATE_UNSPECIFIED: 'Unspecified',
  CLUSTER_HEALTH_STATE_HEALTHY: 'Healthy',
  CLUSTER_HEALTH_STATE_UNHEALTHY: 'Unhealthy', // deprecated: remove once backend stops sending UNHEALTHY
  CLUSTER_HEALTH_STATE_WARNING: 'Warning',
  CLUSTER_HEALTH_STATE_DEGRADED: 'Degraded',
  CLUSTER_HEALTH_STATE_CRITICAL: 'Critical',
  CLUSTER_HEALTH_STATE_DOWN: 'Down'
};

const clusterHealthIntents = {
  CLUSTER_HEALTH_STATE_UNSPECIFIED: 'none',
  CLUSTER_HEALTH_STATE_HEALTHY: 'success',
  CLUSTER_HEALTH_STATE_UNHEALTHY: 'danger', // deprecated: remove once backend stops sending UNHEALTHY
  CLUSTER_HEALTH_STATE_WARNING: 'warning',
  CLUSTER_HEALTH_STATE_DEGRADED: 'severe',
  CLUSTER_HEALTH_STATE_CRITICAL: 'danger',
  CLUSTER_HEALTH_STATE_DOWN: 'critical'
};

const GROUP_HEALTH_STATE_UNSPECIFIED = 'GROUP_HEALTH_STATE_UNSPECIFIED';
const GROUP_HEALTH_STATE_HEALTHY = 'GROUP_HEALTH_STATE_HEALTHY';
const GROUP_HEALTH_STATE_WARNING = 'GROUP_HEALTH_STATE_WARNING';
const GROUP_HEALTH_STATE_DEGRADED = 'GROUP_HEALTH_STATE_DEGRADED';
const GROUP_HEALTH_STATE_CRITICAL = 'GROUP_HEALTH_STATE_CRITICAL';
const GROUP_HEALTH_STATE_DOWN = 'GROUP_HEALTH_STATE_DOWN';

const groupHealthStatusLabels = {
  GROUP_HEALTH_STATE_UNSPECIFIED: 'Unspecified',
  GROUP_HEALTH_STATE_HEALTHY: 'Healthy',
  GROUP_HEALTH_STATE_UNHEALTHY: 'Unhealthy', // deprecated: remove once backend stops sending UNHEALTHY
  GROUP_HEALTH_STATE_WARNING: 'Warning',
  GROUP_HEALTH_STATE_DEGRADED: 'Degraded',
  GROUP_HEALTH_STATE_CRITICAL: 'Critical',
  GROUP_HEALTH_STATE_DOWN: 'Down'
};

const groupHealthIntents = {
  GROUP_HEALTH_STATE_UNSPECIFIED: 'none',
  GROUP_HEALTH_STATE_HEALTHY: 'success',
  GROUP_HEALTH_STATE_UNHEALTHY: 'danger', // deprecated: remove once backend stops sending UNHEALTHY
  GROUP_HEALTH_STATE_WARNING: 'warning',
  GROUP_HEALTH_STATE_DEGRADED: 'severe',
  GROUP_HEALTH_STATE_CRITICAL: 'danger',
  GROUP_HEALTH_STATE_DOWN: 'critical'
};

const SYNTHETICS = 'Synthetics';

const NOT_AUTHORIZED = 'Not Authorized';
const RUNNING = 'Running';
const DOWN = 'Down';
const DISABLED = 'Disabled';
const WARNING = 'Warning';
const DEGRADED = 'Degraded';
const CRITICAL = 'Critical';
const UP = 'Up';
const PENDING = 'Pending';
const UNKNOWN = 'Unknown';

const agentHealthStatusLabels = {
  AGENT_HEALTH_STATE_HEALTHY: 'Healthy',
  AGENT_HEALTH_STATE_WARNING: 'Warning',
  AGENT_HEALTH_STATE_DEGRADED: 'Degraded',
  AGENT_HEALTH_STATE_CRITICAL: 'Critical',
  AGENT_HEALTH_STATE_DOWN: 'Down'
};

const agentHealthIntents = {
  AGENT_HEALTH_STATE_HEALTHY: 'success',
  AGENT_HEALTH_STATE_WARNING: 'warning',
  AGENT_HEALTH_STATE_DEGRADED: 'severe',
  AGENT_HEALTH_STATE_CRITICAL: 'danger',
  AGENT_HEALTH_STATE_DOWN: 'critical'
};

const capabilityHealthStatusLabels = {
  CAPABILITY_HEALTH_STATE_HEALTHY: 'Healthy',
  CAPABILITY_HEALTH_STATE_WARNING: 'Warning',
  CAPABILITY_HEALTH_STATE_DEGRADED: 'Degraded',
  CAPABILITY_HEALTH_STATE_CRITICAL: 'Critical',
  CAPABILITY_HEALTH_STATE_DOWN: 'Down',
  CAPABILITY_HEALTH_STATE_DISABLED: 'Disabled',
  CAPABILITY_HEALTH_STATE_UNSPECIFIED: 'Unknown'
};

const capabilityHealthIntents = {
  CAPABILITY_HEALTH_STATE_HEALTHY: 'success',
  CAPABILITY_HEALTH_STATE_WARNING: 'warning',
  CAPABILITY_HEALTH_STATE_DEGRADED: 'severe',
  CAPABILITY_HEALTH_STATE_CRITICAL: 'danger',
  CAPABILITY_HEALTH_STATE_DOWN: 'critical',
  CAPABILITY_HEALTH_STATE_DISABLED: 'none',
  CAPABILITY_HEALTH_STATE_UNSPECIFIED: 'none'
};

module.exports = {
  CMD_ARGS_KPROXY_KEBAB,
  CMD_ARGS_KPROXY_KEBAB_OBJ,
  AGENT_HEALTH: {
    AGENT_HEALTH_STATE_HEALTHY: 'AGENT_HEALTH_STATE_HEALTHY',
    AGENT_HEALTH_STATE_WARNING: 'AGENT_HEALTH_STATE_WARNING',
    AGENT_HEALTH_STATE_DEGRADED: 'AGENT_HEALTH_STATE_DEGRADED',
    AGENT_HEALTH_STATE_CRITICAL: 'AGENT_HEALTH_STATE_CRITICAL',
    AGENT_HEALTH_STATE_DOWN: 'AGENT_HEALTH_STATE_DOWN'
  },
  CAPABILITY_TITLES,
  CAPABILITY_DESCRIPTIONS,
  CAPABILITY_HEALTH: {
    CAPABILITY_HEALTH_STATE_HEALTHY: 'CAPABILITY_HEALTH_STATE_HEALTHY',
    CAPABILITY_HEALTH_STATE_WARNING: 'CAPABILITY_HEALTH_STATE_WARNING',
    CAPABILITY_HEALTH_STATE_DEGRADED: 'CAPABILITY_HEALTH_STATE_DEGRADED',
    CAPABILITY_HEALTH_STATE_CRITICAL: 'CAPABILITY_HEALTH_STATE_CRITICAL',
    CAPABILITY_HEALTH_STATE_DOWN: 'CAPABILITY_HEALTH_STATE_DOWN',
    CAPABILITY_HEALTH_STATE_DISABLED: 'CAPABILITY_HEALTH_STATE_DISABLED',
    CAPABILITY_HEALTH_STATE_UNSPECIFIED: 'CAPABILITY_HEALTH_STATE_UNSPECIFIED'
  },
  CAPABILITY_KEYS: {
    KBGP,
    KDNS,
    KDUMMY,
    KPROXY,
    KSNMPTRAP,
    KSYNTH,
    KSYSLOG,
    LIVESYNTH,
    KTRAFFIC,
    RANGER,
    KSQUEEGEE,
    KPTR,
    KMETA
  },
  CLUSTER_HEALTH: {
    CLUSTER_HEALTH_STATE_UNSPECIFIED,
    CLUSTER_HEALTH_STATE_HEALTHY,
    CLUSTER_HEALTH_STATE_WARNING,
    CLUSTER_HEALTH_STATE_DEGRADED,
    CLUSTER_HEALTH_STATE_CRITICAL,
    CLUSTER_HEALTH_STATE_DOWN
  },
  CLUSTER_HEALTH_LABELS: clusterHealthStatusLabels,
  CLUSTER_HEALTH_INTENTS: clusterHealthIntents,
  GROUP_HEALTH: {
    GROUP_HEALTH_STATE_UNSPECIFIED,
    GROUP_HEALTH_STATE_HEALTHY,
    GROUP_HEALTH_STATE_WARNING,
    GROUP_HEALTH_STATE_DEGRADED,
    GROUP_HEALTH_STATE_CRITICAL,
    GROUP_HEALTH_STATE_DOWN
  },
  GROUP_HEALTH_LABELS: groupHealthStatusLabels,
  GROUP_HEALTH_INTENTS: groupHealthIntents,
  AGENT_HEALTH_LABELS: agentHealthStatusLabels,
  AGENT_HEALTH_INTENTS: agentHealthIntents,
  CAPABILITY_HEALTH_LABELS: capabilityHealthStatusLabels,
  CAPABILITY_HEALTH_INTENTS: capabilityHealthIntents,
  GROUP_ID_PREFIX: 'group:',
  Capabilities: {
    // maybe call Capability_Keys? replacing with above is good
    KBGP,
    KDNS,
    KDUMMY,
    KPROXY,
    KSNMPTRAP,
    KSYNTH,
    KSYSLOG,
    LIVESYNTH,
    RANGER,
    KTRAFFIC,
    SYNTHETICS,
    KSQUEEGEE,
    KPTR,
    KMETA
  },
  Statuses: {
    NOT_AUTHORIZED,
    RUNNING,
    DISABLED,
    DOWN,
    WARNING,
    DEGRADED,
    CRITICAL,
    PENDING,
    UP,
    UNKNOWN
  },
  CAPABILITIES_DEFAULT_CONFIGS,
  CAPABILITIES_CURRENTLY_AVAILABLE_TO_ALL: [RANGER, KDNS, LIVESYNTH], // KSNMPTRAP, KSYSLOG, KPROXY, KMETA, and KSQUEEGEE are added by permissions
  CAPABILITIES_CURRENTLY_PLANNED: [KBGP],
  CAPABILITIES_TO_ALWAYS_REMOVE_FROM_PUBLIC: [KPACKET], // UI only setting - do not even show these in the blocked list.
  ALWAYS_SUPPORTED_CAPABILITIES: [RANGER, KSYSLOG, KSNMPTRAP, KDUMMY, KSQUEEGEE, KSYNTH, KMETA] // These are distribution-agnostic so can be installed on any linux distribution
};
